import * as Types from '../../../../generated/types';

import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type StartSsoLoginMutationVariables = Types.Exact<{
  slug: Types.Scalars['String']['input'];
}>;


export type StartSsoLoginMutation = { __typename: 'Mutation', startSsoLogin?: string | null };

export const StartSsoLoginDocument = gql`
    mutation startSsoLogin($slug: String!) {
  startSsoLogin(input: {slug: $slug})
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class StartSsoLoginGQL extends Apollo.Mutation<StartSsoLoginMutation, StartSsoLoginMutationVariables> {
    override document = StartSsoLoginDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }